import React from 'react';
import { noop } from 'lodash';
import { func, string } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { r_search } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';
import { isMacOS } from '../../../utils/environment';
import { KEYBOARD_SHORTCUTS } from '../../Links/QuickSearchLink';
import IconWrapper from '../IconWrapper';
import './style.scss';

const SellerSearchTooltip = ({ shortcut }) => (
    <div className="flex">
        <I18n k="header.tooltip.quick_search" />
        &nbsp;&nbsp;
        {shortcut.split('').map((key) => (
            <span key={key} className="seller-search-shortcut-key flex-center m-l-4">
                {key}
            </span>
        ))}
    </div>
);

SellerSearchTooltip.propTypes = {
    shortcut: string,
};

const SellerQuickSearchLink = ({ onClick = noop }) => {
    const shortcut = isMacOS() ? KEYBOARD_SHORTCUTS.MAC : KEYBOARD_SHORTCUTS.NON_MAC;

    return (
        <IconWrapper onClick={onClick} tooltip={<SellerSearchTooltip shortcut={shortcut} />}>
            <Icon size={19}>{r_search}</Icon>
        </IconWrapper>
    );
};

SellerQuickSearchLink.propTypes = {
    onClick: func,
};

export default SellerQuickSearchLink;
